import { CRMAPIBase } from '@api/crmApiBase';
import { ChatGroupListResp } from '@api/responseModels/chats/chatGroupListResponse';
import { ChatGroupResp } from '@api/responseModels/chats/chatGroupResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class ChatGroupsGroup extends CRMAPIBase {
    async getChatGroups({
        crm_id,
        per_page,
        page,
    }: {
        crm_id: number;
        per_page: number;
        page: number;
    }): Promise<RequestResult<ChatGroupListResp>> {
        const response = await this.get<ChatGroupListResp>(`/chat-groups`, { per_page, page });
        return response;
    }

    /** Группа вместе с вложенными чатами */
    async getChatGroup({
        crm_id,
        chat_group_id,
    }: {
        crm_id: number;
        chat_group_id: number;
    }): Promise<RequestResult<ChatGroupResp>> {
        const response = await this.get<ChatGroupResp>(`/chat-groups/${chat_group_id}`, { crm_id });
        return response;
    }

    async createChatGroup({
        crm_id,
        name,
    }: {
        crm_id?: number;
        name: string;
    }): Promise<RequestResult<ChatGroupResp>> {
        const response = await this.post<ChatGroupResp>(`/chat-groups`, { crm_id, name });
        return response;
    }

    /**
     * Удаление группы. Личную группу и группу с `crm_id` бэк удалять запрещает —
     * возвращает 403 (`ChatGroupController::destroy`).
     */
    async deleteGroup({
        crm_id,
        chat_group_id,
    }: {
        crm_id: number;
        chat_group_id: number;
    }): Promise<RequestResult<ChatGroupResp>> {
        const response = await this.delete<ChatGroupResp>(`/chat-groups/${chat_group_id}`, {
            crm_id,
        });
        return response;
    }
}

export { ChatGroupsGroup };
